<template>
  <div>
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <dialog-table-page ref="history" :pageData="history"></dialog-table-page>
    <slotRebate v-if="isSlotRebate" :isShow="isSlotRebate" :slotData="slotRebateDate" :type="dateUtil.getParamKey(this.$route.params)"
                @changeSlotRebate="changeSlotRebate"
    ></slotRebate>
  </div>
</template>

<script>
import FORM from '@/components/page/form.vue'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import Url from '@/views/proxy/util/url'
import slotRebate from '@/views/proxy/adAgent/components/slotRebate.vue'
import DateUtil from '@/utils/IM/tradeDataUtil'
import Qs from 'qs'
import dialogTablePage from '@/components/page/dialogTable.vue'

let statusArr = { 0: '待审批', 1: '启用', 2: '禁用', 3: '同意', 4: '拒绝' }
let platformArr = { 'GTS2': 'GTS2', 'MT5': 'MT5' }
//data.groupId = Object.values(this.$route.params)[0];
export default {
  name: 'rebateSet',
  components: {
    FORM,
    tablePage,
    UPDATE,
    slotRebate,
    dialogTablePage
  },
  data() {
    return {
      dateUtil:DateUtil,
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '返佣组件名称', field: 'name' },
          { field: 'groupId', data: DateUtil.getParamKey(this.$route.params), hidden: true },
          {
            title: '類型',
            field: 'status',
            type: 2,
            optionList: statusArr,
            data: []
          },
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          { click: window.$t('common.search') },
          { click: window.$t('common.add'), auth: 'proxy:rebateSet:add' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.rebateSetList + '?groupId=' + DateUtil.getParamKey(this.$route.params),
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: 'ID', field: 'id' },
          { title: '返佣组件名称', field: 'name' },
          { title: '支持平台', field: 'platform' },
          { title: '级别', field: 'level' },
          {
            title: '组件状态', field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          { title: '创建人', field: 'cname' },
          {
            title: '创建时间', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '审批人', field: 'uname' },
          {
            title: '审批时间', field: 'utime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'proxy:rebateSet:del'
              },
              {
                name: window.$t('common.edit'),
                click: 'update',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'proxy:rebateSet:edit'
              },
              {
                name: window.$t('common.approve'),
                click: 'approve',
                type: 'primary',
                icon: 'el-icon-approve',
                auth: 'proxy:rebateSet:approve', hidden: (data, full) => {
                  return full.status == 1
                }
              },
              {
                name: window.$t('common.reject'),
                click: 'reject',
                type: 'primary',
                icon: 'el-icon-reject',
                auth: 'proxy:rebateSet:reject', hidden: (data, full) => {
                  return full.status == 2
                }
              },
              {
                name: '编辑返佣',
                click: 'editRebate',
                type: 'primary',
                icon: 'el-icon-editRebate',
                auth: 'proxy:rebateSet:editRebate'
              },
              {
                name: '歷史記錄',
                click: 'historyConfig',
                type: 'primary',
                icon: 'el-icon-editRebate',
                auth: 'proxy:rebateSet:historyConfig'
              }
            ]
          }
        ]
      },
      /*新增或更新*/
      updateData: {
        cols: [
          { title: 'ID', field: 'id', hidden: true },
          { title: '返佣组件名称', field: 'name', data: '', required: true },
          { field: 'groupId', data: DateUtil.getParamKey(this.$route.params), hidden: true },
          {
            title: '支持平台',
            field: 'platform',
            type: 4,
            optionList: platformArr,
            data: ['GTS2', 'MT5'],
            required: true,
            disabled: true
          }
        ]
      },
      history: {
        queryUrl: Url.adAgent.symbolHistory, //请求路径和参数
        title: '歷史記錄',
        sync: false,
        isShow: false,
        sequence: true,
        method: 'get',
        cols: [
          { title: 'settingId', field: 'settingId' },
          { title: '操作人', field: 'uname' },
          {
            title: '時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: 'rule', field: 'rule' }
        ]
      },

      slotRebateDate: {},
      isSlotRebate: false
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if (window.$t('common.add') == clickName || '增加' == clickName) {
        this.$refs.childUpdate.open()
      }
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        row.platform = row.platform ? row.platform.split(',') : ''
        this.$refs.childUpdate.open(row)
      } else if (clickName == 'editRebate') {
        row.platform = row.platform.split(',')
        this.$axios.get(Url.adAgent.rebateSetDetail + '?id=' + row.id).then(res => {
          if (res.code == 0) {
            let data = []
            if (JSON.stringify(res.result.configMap) != '{}') {
              for (const val of Object.values(res.result.configMap)) {
                val.rule = JSON.parse(val.rule)
                data.push(val)
              }
              row.rule = data
            }
            row.totalMap = []
            row.level = res.result.level
            if (row.level > 0) {
              for (let i = 0; i < res.result.level; i++) {
                row.totalMap.push({ level: (i + 1), amount: '' })
              }
            } else {
              row.totalMap.push({ level: 1, amount: '' })
            }
            this.slotRebateDate = {
              level: row.level,
              name: row.name,
              settingId: row.id,
              platform: row.platform,
              totalMap: row.totalMap,
              rule: row.rule
            }
            this.isSlotRebate = true
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'delete') {
        let option = {
          id: row.id,
          groupId: DateUtil.getParamKey(this.$route.params)
        }
        this.dataChange(Url.adAgent.rebateSetDel, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'reject' || clickName == 'approve') {
        let option = {
          id: row.id,
          status: clickName == 'approve' ? 1 : 2
        }
        this.dataChange(Url.adAgent.rebateSetStatus, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'historyConfig') {
        this.historyConfig(row)
      }
    },
    changeSlotRebate(val) {
      this.isSlotRebate = val
      this.$refs.childTable.defaultGetData(this.queryData)
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.platform = model.platform.join(',')
      this.dataChange(Url.adAgent.rebateSetEdit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    historyConfig(row) {
      this.history.sync = true
      let data = { 'settingId': row.id }
      this.$refs.history.defaultQueryData(data)
    }
  }
}
</script>

<style scoped>

</style>
